import React from 'react';
import moment from 'moment';

import {
    Card,
    Table,
    DatePicker,
    Button,
    message,
} from 'antd';

import {
    _getProductLogs
} from '../../services'

const { RangePicker } = DatePicker

const ACTIONS = [
    {text: "PRICE_CHANGE", value: "PRICE_CHANGE"},
    {text: "ACTIVE_TOGGLE", value: "ACTIVE_TOGGLE"},
    {text: "CONTINUE_TOGGLE", value: "CONTINUE_TOGGLE"},
    {text: "TITLE_CHANGE", value: "TITLE_CHANGE"},
    {text: "CATEGORY_CHANGE", value: "CATEGORY_CHANGE"},
    {text: "BRAND_CHANGE", value: "BRAND_CHANGE"},
    {text: "MODEL_CHANGE", value: "MODEL_CHANGE"},
    {text: "DIMENSION_CHANGE", value: "DIMENSION_CHANGE"},
    {text: "DISCOUNT_CHANGE", value: "DISCOUNT_CHANGE"},
    {text: "MOQ_CHANGE", value: "MOQ_CHANGE"},
    {text: "VARIANT_CHANGE", value: "VARIANT_CHANGE"},
    {text: "SUPPLIER_CHANGE", value: "SUPPLIER_CHANGE"},
    {text: "PRODUCT_DUPLICATED", value: "PRODUCT_DUPLICATED"},
    {text: "PRODUCT_REMOVED", value: "PRODUCT_REMOVED"},
]

class ProductLogs extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            data: [],
            actionFilter: [],
            userDict: {},

            startDate: moment().startOf('day'),
            endDate: moment().endOf('day'),
            lastRefresh: moment()
        }
    }

    render() {

        return(
            <Card
                title=
                {<div style={{display: 'flex', alignItems: 'center'}}>
                    {this.renderRangePicker()}
                    <Button onClick={this.handleLiveClicked}  style={{marginBottom: 0, marginLeft: 10}} type='primary'>Live Data</Button>
                    <div style={{marginLeft: 'auto'}}>
                        <p style={{marginBottom: 0}}>Last Refresh: {moment(this.state.lastRefresh).format('DD-MM-YYYY HH:mm')}</p>
                    </div>
                </div>}
            >
                {this.renderChangeTable()}
            </Card>
        )
    }

    componentDidMount() {
        this.getProductLogs()
        this.hotReload()
    }

    hotReload = () => {
        this.getProductLogs()
        setTimeout( this.hotReload, 60000 ) // every minute
    }

    getProductLogs = () => {

        const {startDate, endDate, actionFilter} = this.state;

        _getProductLogs({
            startDate: startDate.format('YYYY-MM-DD'), 
            endDate: endDate.format('YYYY-MM-DD'),
            actionFilter,
        })
        .then(data => {
            this.setState({
                data: data.data.events,
                userDict: data.data.userDict,
                lastRefresh: moment()
            })
        })
    }

    renderRangePicker = () => {

        const {startDate, endDate} = this.state
        return(
            <div style={{display:'flex', }}>
                    <p style={{marginBottom: 0, marginRight: 10}}>Date Range:</p>
                    <RangePicker
                        value={[startDate, endDate]}
                        onChange={this.handleDateChange}
                    />
            </div>
        )
    }

    renderChangeTable = () => {

        const { data, userDict } = this.state

        const columns = [{
            title: 'Time',
            dataIndex: 'timestamp',
            render: (timestamp) => moment(timestamp).format('LL'),
            width: 120
        },{
            title: 'Action',
            dataIndex: 'page_type',
            filters: ACTIONS,
            filteredValue: this.state.actionFilter
        }, {
            title: 'User',
            dataIndex: 'user_id',
            render: (user_id) => userDict[user_id] && userDict[user_id].email
        }, {
            title: 'Product Title',
            dataIndex: 'product_title',
        }, {
            title: 'Value',
            dataIndex: 'value',
        }
        ]

        return (
            <Table
                onChange={this.handleTableChange}
                dataSource={data}
                columns={columns}
                pagination={false}
                size="small"
            />
        )
    }

    handleTableChange = (pagination, filters, sorter, extra) => {
        console.log({filters})
        this.setState({
            actionFilter: filters.page_type,
            current: pagination.current
        }, this.getProductLogs)
    }

    handleDateChange = (values) => {
        this.setState({
            startDate: values[0],
            endDate: values[1]
        },this.getProductLogs)
    }

    handleLiveClicked = () => {
        this.setState({
            startDate: moment(),
            endDate: moment()
        },this.getProductLogs)
        message.success(`Date Range set to today's date!`, 10)
    }
}

export default ProductLogs


// WEBPACK FOOTER //
// ./src/components/product/product-logs.js